<template>
  <tr>
    <td>
      <router-link :to="{ path: '/membership/members/' + driver.uuid }">
        {{ driver.dropdownLabel }}
      </router-link>
    </td>
    <td>
      <div class="text-center">
        <span class="fa" :class="driver.CreditCards.length ? 'fa-check text-success' : 'fa-times text-danger'"></span>
      </div>
    </td>
    <td>
      <span class="badge" :class="membershipStatus.label">
        {{ membershipStatus.text }}
      </span>
    </td>
    <td>
      <dropdown-input label="Actions"
        label-icon="fa-calendar-alt"
        :actions="driverActions"
        :dropright="true"
        @action="executeAction($event, driver)">
      </dropdown-input>
    </td>
  </tr>
</template>

<script>
import DropdownInput from '@/components/inputs/DropdownInput'
import { mapGetters, mapActions } from 'vuex'
import {
  MAKE_MASTER_ACCOUNT,
  REMOVE_DRIVER
} from '@/vuex/types'

export default {
  name: 'DriverRow',
  props: {
    object: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  components: {
    DropdownInput
  },
  computed: {
    ...mapGetters([
      'driverActions'
    ]),
    membershipStatus () {
      let label = ''
      let text = ''
      if (this.driver.memberQuit) {
        label = 'badge-warning'
        text = 'Quit'
      } else if (this.driver.restricted) {
        label = 'badge-danger'
        text = 'Restricted'
      } else if (!this.driver.activated) {
        label = 'badge-default'
        text = 'Inactive'
      } else {
        label = 'badge-success'
        text = 'Active'
      }
      return { label, text }
    },
    driver () {
      return {
        ...this.object
      }
    }
  },
  methods: {
    async executeAction (action, payload) {
      await this[action](payload)
    },
    ...mapActions([
      MAKE_MASTER_ACCOUNT,
      REMOVE_DRIVER
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/rows/Driver.vue